import React, { useState } from "react";
import SnakBar from '../../alert/Toast';
import { wglcsApiService } from "../../../services/WglcsApiService";
import { DetectEnvironment } from "../../../EnvironmentSettings";
const WelcomePage = (props) => {

    const [companyWebsite, setCompanyWebsite] = useState<string>('')
    const [companyWebsiteError, setCompanyWebsiteError] = useState<string>('')
    const [companyName, setCompanyName] = useState<string>('')
    const [companyNameError, setCompanyNameError] = useState<string>('')
    const [firstName, setFirstName] = useState<string>('')
    const [firstNameError, setFirstNameError] = useState<string>('')
    const [lastName, setLastName] = useState<string>('')
    const [lastNameError, setLastNameError] = useState<string>('')
    const [email, setEmail] = useState<string>('')
    const [emailError, setEmailerror] = useState<string>('')
    const [phone, setPhone] = useState<string>('')
    const [phoneError, setPhoneError] = useState<string>('')
    const [pakageId, setPakageId] = useState<string>('')
    const [severity, setSeverity] = useState<string>('')
    const [message, setMessage] = useState<string>('')
    const [openSnakBar, setOpenSnakBar] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    const saveSignUp = async () => {

        if (validations()) {
            setLoading(true)
            let obj = {
                packageId: '3',
                domainName: companyWebsite,
                companyName: companyName,
                firstName: firstName,
                lastName: lastName,
                email: email,
                phone: phone,
            };
            try {
                const response = await fetch('https://dev1.thelivechatsoftware.com/ChatAppApi/api/wglcs/packagepresignup', {
                    // const response = await fetch('http://172.16.0.12:8085/api/wglcs/packagepresignup', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(obj),
                    mode: 'cors',
                });

                const data = await response.json();
                if (data?.data == true) {
                    setLoading(false)
                    props.currentScreen(2)
                }
                // console.log('df res', data)
                setSeverity("error")
                setMessage(data?.error[0]?.Message)
                setOpenSnakBar(true)
                console.error('df:', data.error[0].Message);
                setLoading(false)
            } catch (error) {
                console.log('Error making the request:', error);
                setLoading(false)
            }
        };
        // try {
        // const response = await wglcsApiService.signUp(obj);
        // const response = await wglcsApiService.signUpPost(obj);

        // console.log('signup successful:', response);
        // setLoading(false)
        // if (response?.data?.status == true) {
        //     alert(response?.data?.msg)
        //     console.log('signup successful:', response);
        //     props.currentScreen(2);
        // } else {
        //     console.log('signup failed.');
        // }
        // } catch (error) {
        //     console.log('Error during signup:', error);
        //     setLoading(false)
        // }
        // props.currentScreen(2);
    }
    // }

    const validateEmail = (email) => {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    const validatePhone = (phone) => {
        const re = /^[0-9]*$/;
        return re.test(String(phone).toLowerCase());
    };

    const validations = () => {
        let isFormValid = true;
        if (companyWebsite.trim() == '') {
            setCompanyWebsiteError('*Required')
            isFormValid = false;
        }
        if (companyName.trim() == '') {
            setCompanyNameError('*Required')
            isFormValid = false;
        }
        if (firstName.trim() == '') {
            setFirstNameError('*Required')
            isFormValid = false;
        }

        if (lastName.trim() == '') {
            setLastNameError('*Required')
            isFormValid = false;
        }
        if (email.trim() == '') {
            setEmailerror('*Required')
            isFormValid = false;
        }
        if (validateEmail(email) == false) {
            setEmailerror("*Email Address is not valid")
            isFormValid = false;
        }
        if (phone.trim() == '') {
            setPhoneError('*Required')
            isFormValid = false;
        }
        if (validatePhone(phone) == false) {
            setPhoneError("*Phone No is not valid")
            isFormValid = false;
        }
        return isFormValid;
    }
    const handeCloseSnakbar = () => {
        setOpenSnakBar(false)
    }

    return (
        <div className="welcome-wrapper">
            <div className="row" >
                <div className="col-lg-9">
                    <img className="welcome-page-logo" src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="logo" />
                    <div className="row justify-content-lg-center welcome-pad">
                        <div className="col-lg-9">
                            <div className="signup-form-wrapper">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="la-heading">
                                            Welcome to LiveAdmins
                                        </div>
                                    </div>
                                </div>

                                <div className="row">

                                    <div className="col-lg-6">
                                        <span className="signup-icon">
                                            <i className="fa fa-globe"></i>
                                            <input value={companyWebsite} onChange={(e) => { setCompanyWebsiteError(''); setCompanyWebsite(e.target.value) }} className="signup-input" placeholder="Company Website" />
                                            {companyWebsiteError && <div className="error-text">{companyWebsiteError}</div>}
                                        </span>
                                    </div>

                                    <div className="col-lg-6">
                                        <span className="signup-icon">
                                            <i className="fa-light fa-building"></i>
                                            <input value={companyName} onChange={(e) => { setCompanyNameError(''); setCompanyName(e.target.value) }} className="signup-input" placeholder="Company Name" />
                                            {companyNameError && <div className="error-text">{companyNameError}</div>}
                                        </span>

                                    </div>

                                    <div className="col-lg-6">
                                        <span className="signup-icon">
                                            <i className="fa-light fa-user-circle"></i>
                                            <input value={firstName} onChange={(e) => { setFirstNameError(''); setFirstName(e.target.value) }} className="signup-input" placeholder="First Name" />
                                            {firstNameError && <div className="error-text">{firstNameError}</div>}
                                        </span>

                                    </div>
                                    <div className="col-lg-6">
                                        <span className="signup-icon">
                                            <i className="fa-light fa-user-circle"></i>
                                            <input value={lastName} onChange={(e) => { setLastNameError(''); setLastName(e.target.value) }} className="signup-input" placeholder="Last Name" />
                                            {lastNameError && <div className="error-text">{lastNameError}</div>}
                                        </span>

                                    </div>
                                    <div className="col-lg-6">
                                        <span className="signup-icon">
                                            <i className="fa-light fa-envelope"></i>
                                            <input value={email} onChange={(e) => { setEmailerror(''); setEmail(e.target.value) }} className="signup-input" placeholder="Email" />
                                            {emailError && <div className="error-text">{emailError}</div>}
                                        </span>

                                    </div>
                                    <div className="col-lg-6">
                                        <span className="signup-icon">
                                            <i className="fa-light fa-phone"></i>
                                            <input type='number' value={phone} onChange={(e) => { setPhoneError(''); setPhone(e.target.value) }} className="signup-input" placeholder="Phone No" />
                                            {phoneError && <div className="error-text">{phoneError}</div>}
                                        </span>

                                    </div>
                                    <div className="col-lg-12 text-center">
                                        <button disabled={loading ? true : false} onClick={() => saveSignUp()} className="signup-btn">
                                            SIGN UP
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="right-bar welcome-right-bar col-lg-3" >
                    <div>
                    </div>
                </div>
            </div>
            <SnakBar
                open={openSnakBar}
                severity={severity}
                message={message}
                handleClose={handeCloseSnakbar}
            />
        </div>
    )
}
export default WelcomePage;